import { useState } from 'react';
import { ParticipantListCount, ParticipantListSearch, SpeakerListRows } from '../../molecules';
import { ParticipantListRows } from '../../molecules/ParticipantListRows';

export const ParticipantList = () => {
    const [search, setSearch] = useState<string>('');

    return (
        <div className="flex-1 bg-white flex flex-col p-2">
            <SpeakerListRows />
            <ParticipantListCount />
            <ParticipantListSearch onSearchChange={(search) => setSearch(search)} />
            <ParticipantListRows search={search} />
        </div>
    );
};
